import VueMatomo from 'vue-matomo';

const matomoPlugin = {
  install(app, options) {
    const { router } = options;
    const matomoHost =
      process.env.NODE_ENV == 'development'
        ? 'https://matomo.ddev.site'
        : ~new URL(window.location).href.indexOf("stage.siresca.ch")
        ? '//analytics-stage.siresca.ch'
        : '//analytics.siresca.ch';
    const matomoConfig = {
      host: matomoHost,
      siteId: 1,
      trackerFileName: 'matomo',
      router: router,
      enableLinkTracking: true,
      requireConsent: false,
      trackInitialView: true,
      disableCookies: false,
      requireCookieConsent: true,
      enableHeartBeatTimer: false,
      heartBeatTimerInterval: 15,
      debug: false,
      userId: undefined,
      cookieDomain: undefined,
      domains: undefined,
      preInitActions: [],
      trackSiteSearch: false
    };
    app.use(VueMatomo, matomoConfig);
    console.log('Inited matomo');
  }
};

export default matomoPlugin;
